export const decisioningStudioAgentsAppGroupIdDsaIdSourceCanvases =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/source_canvases";
